export class UserLogin {
  constructor(userid?: string, password?: string) {
    this.userid = userid;
    this.password = password;
  }

  userid: string;
  password: string;
}
